import { ActionDataTransformation } from './AnalyticsManager.types'

export default {
	[ActionDataTransformation.REGEX](value: string, regex: string, global = true): string {
		try {
			const reg = new RegExp(regex, global ? 'g' : '')
			return value.replace(reg, '')
		} catch (error) {
			console.error('Invalid regex:', regex, error)
			return value
		}
	},
	[ActionDataTransformation.JSON_STRINGIFY](value: unknown): string {
		try {
			
			return JSON.stringify(value)
		} catch (error) {
			console.error('Failed to parse JSON:', value, error)

			return ''
		}
	},
}
